export const useContent = async () => {
  const route = useRoute()
  const { locale } = useI18n()

  async function getContent(contentId: string) {
    return await useAsyncData(
      `content-${route.path}-${locale.value}-${contentId}`,
      async () => {
        const response = await $fetch('/api/v1/contentful/investor/content', {
          query: {
            locale: locale.value,
            path: route.params.url,
            id: contentId,
          },
        })

        const content = response.content ?? null
        return content
      })
  }

  return {
    getContent,
  }
}
